import arrayUtilities from "./arrayUtilities";
import stringHelpers from "./stringHelpers";
import { toDateString } from "./dateUtilities";

const hasRemainingFilters = filters => Object.values(filters).some(value => !stringHelpers.isNullOrEmpty(value) || !arrayUtilities.isNullOrEmpty(value))

export default {
    hasRemainingFilters,

    applyDateRange(previousFilters, labelPrefix, firstDate, lastDate, presetLabel) {
        const rangeLabel = `${ labelPrefix } Range`
        const fromLabel = `${ labelPrefix } From`
        const toLabel = `${ labelPrefix } To`
        const isFirstDateEmpty = firstDate === null || firstDate === ""
        const isLastDateEmpty = lastDate === null || lastDate === ""
        const updatedFilters = { ...previousFilters }
        delete updatedFilters[rangeLabel]
        delete updatedFilters[fromLabel]
        delete updatedFilters[toLabel]
        if (!stringHelpers.isNullOrEmpty(presetLabel)) {
            updatedFilters[rangeLabel] = presetLabel
        } else if (!isFirstDateEmpty && !isLastDateEmpty) {
            updatedFilters[rangeLabel] = `${ toDateString(new Date(firstDate)) } - ${ toDateString(new Date(lastDate)) }`
        } else {
            if (!isFirstDateEmpty) {
                updatedFilters[fromLabel] = toDateString(new Date(firstDate))
            }
            if (!isLastDateEmpty) {
                updatedFilters[toLabel] = toDateString(new Date(lastDate))
            }
        }
        return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
    },

    applyMultiSelection(previousFilters, label, selectedIds, allItems) {
        const updatedFilters = { ...previousFilters }
        if (!arrayUtilities.isNullOrEmpty(selectedIds)) {
            if (selectedIds.length === 1) {
                const selectedItem = allItems.find(item => item.id === selectedIds[0])
                if (selectedItem !== undefined) {
                    updatedFilters[label] = selectedItem.name
                }
            } else {
                updatedFilters[label] = allItems.filter(item => selectedIds.includes(item.id))
            }
        } else {
            delete updatedFilters[label]
        }
        return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
    },

    keepMultiSelectionItems(previousFilters, label, remainingIds) {
        const updatedFilters = { ...previousFilters }
        const remainingItems = previousFilters[label].filter(item => remainingIds.includes(item.id))
        if (arrayUtilities.isNullOrEmpty(remainingItems)) {
            delete updatedFilters[label]
        } else if (remainingItems.length === 1) {
            updatedFilters[label] = remainingItems[0].name
        } else {
            updatedFilters[label] = remainingItems
        }
        return hasRemainingFilters(updatedFilters) ? updatedFilters : null
    }
}
